<template>
  <transition name="fade">
    <div v-if="show" class="advanced-filters column">
      <q-expansion-item
        v-if="isVind && !isSmeDisabled"
        dense
        dense-toggle
        expand-icon="chevron_right"
        v-model="orgFiltersExpanded"
      >
        <template #header>
          <div
            class="q-item__section column q-item__section--main justify-center"
          >
            <div
              role="button"
              :aria-expanded="orgFiltersExpanded.toString()"
              aria-controls="org-content"
              class="q-item__label"
            >
              {{ t("search_schemes.sme_organization_question") }}
            </div>
          </div>
        </template>
        <template #default>
          <div id="org-content" :aria-hidden="(!orgFiltersExpanded).toString()">
            <div class="sidebar-margin item-width white-bg-box">
              <div class="column">
                <q-checkbox
                  dense
                  size="sm"
                  v-model="sme"
                  val="sm"
                  :label="t('search_schemes.yes')"
                  class="checkbox"
                  :disable="isSmeDisabled"
                />
                <q-checkbox
                  dense
                  size="sm"
                  v-model="notSme"
                  val="sm"
                  :label="t('search_schemes.no')"
                  class="checkbox"
                  :disable="isSmeDisabled"
                />
              </div>
            </div>
          </div>
        </template>
      </q-expansion-item>

      <q-expansion-item
        v-if="isVind"
        dense
        dense-toggle
        expand-icon="chevron_right"
        v-model="submissionFiltersExpanded"
      >
        <template #header>
          <div
            class="q-item__section column q-item__section--main justify-center"
          >
            <div
              role="button"
              :aria-expanded="submissionFiltersExpanded.toString()"
              aria-controls="submission-content"
              class="q-item__label"
            >
              {{ t("search_schemes.submission_procedure") }}
            </div>
          </div>
        </template>
        <template #default>
          <div
            id="submission-content"
            :aria-hidden="(!submissionFiltersExpanded).toString()"
          >
            <div class="input-box">
              <div class="column">
                <q-checkbox
                  dense
                  size="sm"
                  v-model="before"
                  val="sm"
                  :label="t('search_schemes.before')"
                  class="checkbox"
                />
                <q-checkbox
                  dense
                  size="sm"
                  v-model="after"
                  val="sm"
                  :label="t('search_schemes.after')"
                  class="checkbox"
                />
                <q-checkbox
                  dense
                  size="sm"
                  v-model="beforeAndAfter"
                  val="sm"
                  :label="t('search_schemes.before_and_after')"
                  class="checkbox"
                />
              </div>
            </div>
          </div>
        </template>
      </q-expansion-item>

      <q-expansion-item
        dense
        dense-toggle
        class="q-mb-md"
        expand-icon="chevron_right"
        v-model="searchSchemeFiltersExpanded"
      >
        <template #header>
          <div
            class="q-item__section column q-item__section--main justify-center"
          >
            <div
              role="button"
              :aria-expanded="searchSchemeFiltersExpanded.toString()"
              aria-controls="scheme-content"
              class="q-item__label"
            >
              {{ t("search_schemes.scope") }}
            </div>
          </div>
        </template>
        <template #default>
          <div
            id="scheme-content"
            :aria-hidden="(!searchSchemeFiltersExpanded).toString()"
          >
            <div class="input-box">
              <div class="column">
                <q-option-group
                  dense
                  v-model="selectedScopes"
                  :options="scopeOptions"
                  type="checkbox"
                  class="scopes-option-group"
                  size="sm"
                />
              </div>
            </div>
          </div>
        </template>
      </q-expansion-item>
    </div>
  </transition>
</template>

<script>
import { ref, computed, watch, onMounted } from "vue";
import store from "../../store/index";
import SchemeUtils from "../../utils/schemes";
import { useI18n } from "vue-i18n";
import FiltersService from "../../services/filters.service";

export default {
  setup() {
    const { locale } = useI18n();

    const orgFiltersExpanded = ref(false);
    const submissionFiltersExpanded = ref(false);
    const searchSchemeFiltersExpanded = ref(false);
    const isSmeDisabled = ref(false);

    const selectedAudiences = computed({
      get: () =>
        store.state.advancedSearch.selectedAudiences != ""
          ? store.state.advancedSearch.selectedAudiences
          : sessionStorage.getItem("selectedAudiences"),
    });
    const ondernemerTagsIds = computed({
      get: () => store.state.advancedSearch.ondernemerTagsIds,
    });
    const show = computed({
      get: () => store.state.advancedFilters.showAdvancedFilters,
    });
    const sme = computed({
      get: () => store.state.advancedFilters.sme,
      set: async (val) => {
        store.commit("advancedSearch/enableFiltersChange");
        store.commit("advancedFilters/updateSme", val);
        if (!isSearchPaused.value) await SchemeUtils.searchSchemes(locale);
      },
    });

    onMounted(() => {
      FiltersService.getScopes();
      if (selectedAudiences.value == null || selectedAudiences.value == "") {
        isSmeDisabled.value = true;
      }
    });
    const notSme = computed({
      get: () => store.state.advancedFilters.notSme,
      set: async (val) => {
        store.commit("advancedSearch/enableFiltersChange");
        store.commit("advancedFilters/updateNotSme", val);
        if (!isSearchPaused.value) await SchemeUtils.searchSchemes(locale);
      },
    });
    const before = computed({
      get: () => store.state.advancedFilters.before,
      set: async (val) => {
        store.commit("advancedSearch/enableFiltersChange");
        store.commit("advancedFilters/updateTermBefore", val);
        if (!isSearchPaused.value) await SchemeUtils.searchSchemes(locale);
      },
    });
    const after = computed({
      get: () => store.state.advancedFilters.after,
      set: async (val) => {
        store.commit("advancedSearch/enableFiltersChange");
        store.commit("advancedFilters/updateTermAfter", val);
        if (!isSearchPaused.value) await SchemeUtils.searchSchemes(locale);
      },
    });
    const beforeAndAfter = computed({
      get: () => store.state.advancedFilters.beforeAndAfter,
      set: async (val) => {
        store.commit("advancedSearch/enableFiltersChange");
        store.commit("advancedFilters/updateTermBoth", val);
        if (!isSearchPaused.value) await SchemeUtils.searchSchemes(locale);
      },
    });

    // We have to map options for the q-option-group like this until we upgrade quasar version to 2.17+
    // Attributes 'option-label' and 'option-value' are available for this element in quasar starting from the version 2.17
    // Updating quasar version above the current version requires using node version 18+ and possibly webpack version 5
    const scopeOptions = computed(() =>
      store.state.advancedFilters.scopeOptions.map((s) => ({
        value: s.id,
        label: s.description,
      }))
    );
    const selectedScopes = computed({
      get: () => store.state.advancedFilters.selectedScopes,
      set: async (val) => {
        store.commit("advancedSearch/enableFiltersChange");
        store.commit("advancedFilters/updateSelectedScopes", val);
        if (!isSearchPaused.value) await SchemeUtils.searchSchemes(locale);
      },
    });

    const isVind = computed({
      get: () => store.state.auth.env === 0 || store.state.auth.env === 40,
    });
    const isSearchPaused = computed({
      get: () => store.state.advancedSearch.applySavedSearchPause,
    });

    const updateIsSmeDisabled = () => {
      let selectedAudiencesIds = selectedAudiences.value
        ? selectedAudiences.value.split(",").map(Number)
        : [];
      isSmeDisabled.value = !ondernemerTagsIds.value.some((id) =>
        selectedAudiencesIds.includes(id)
      );

      if (isSmeDisabled.value == true) {
        store.commit("advancedFilters/updateSme", false);
        store.commit("advancedFilters/updateNotSme", false);
        store.commit("advancedFilters/clearSMEString");
      }
    };

    const resetValues = async () => {
      store.commit("advancedFilters/updateSme", false);
      store.commit("advancedFilters/updateNotSme", false);
      store.commit("advancedFilters/updateTermBefore", false);
      store.commit("advancedFilters/updateTermAfter", false);
      store.commit("advancedFilters/updateTermBoth", false);
      if (!isSearchPaused.value) await SchemeUtils.searchSchemes(locale);
    };

    onMounted(() => {
      if (selectedAudiences.value == null || selectedAudiences.value == "") {
        isSmeDisabled.value = true;
      }
    });

    watch(selectedAudiences, () => {
      updateIsSmeDisabled();
    });

    return {
      isSmeDisabled,
      ondernemerTagsIds,
      selectedAudiences,
      isVind,
      isSearchPaused,
      sme,
      notSme,
      before,
      show,
      after,
      beforeAndAfter,
      selectedScopes,
      scopeOptions,
      orgFiltersExpanded,
      submissionFiltersExpanded,
      searchSchemeFiltersExpanded,
      resetValues,
    };
  },
};
</script>
